import React from 'react'
import { Typography } from '@mui/material'
import classes from './Paragraph.module.css'

const Paragraph = (props) => {
    return (
        <Typography
            variant="p"
            component="p"
            className={classes.paragraph}
            sx={{
                color: props.color || "#242424",
                fontSize: props.fontSize || '14px',
                margin: props.margin === undefined ? '0 0 8px 0' : props.margin,
                textAlign:props.textalign,
                fontWeight: props.fontWeight,
                ...props.sx
            }}
        >
            {props.text}
        </Typography>
    )
}

export default Paragraph